(() => {
  const browser = document.querySelector('.hz-collection-browser');
  if (!browser) return;
  const panel = browser.querySelector('#CollectionFilterPanel');
  const trigger = browser.querySelector('[data-open-filters]');
  const desktop = window.matchMedia('(min-width: 901px)');
  const drawerOnly = browser.hasAttribute('data-filter-drawer');
  let savedOverflow = null;
  const unlock = () => {
    if (savedOverflow !== null) document.body.style.overflow = savedOverflow;
    savedOverflow = null;
    trigger.setAttribute('aria-expanded', 'false');
  };
  const closePanel = () => { panel.close(); unlock(); trigger.focus({ preventScroll: true }); };
  const syncPanel = () => { if (panel.open) panel.close(); unlock(); if (desktop.matches && !drawerOnly) panel.setAttribute('open', ''); };
  syncPanel();
  desktop.addEventListener('change', syncPanel);
  trigger.addEventListener('click', () => {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.showModal();
    trigger.setAttribute('aria-expanded', 'true');
  });
  panel.querySelector('[data-close-filters]').addEventListener('click', closePanel);
  panel.addEventListener('cancel', event => { event.preventDefault(); closePanel(); });
  panel.addEventListener('click', event => { if (event.target === panel && event.clientX < panel.getBoundingClientRect().left) closePanel(); });
  panel.addEventListener('close', unlock);
  const views = browser.querySelectorAll('[data-grid-columns]');
  const preferenceKey = () => `hz-collection-columns-${desktop.matches ? 'desktop' : 'mobile'}`;
  const setView = columns => {
    browser.dataset.gridColumns = columns;
    views.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gridColumns === columns)));
    browser.querySelectorAll('#CollectionProductGrid img').forEach(image => { image.sizes = columns === '1' ? '(min-width: 901px) 40vw, 94vw' : '(min-width: 901px) 43vw, 46vw'; });
  };
  const restoreView = () => {
    let columns = '2';
    try { const saved = localStorage.getItem(preferenceKey()); if (saved === '1' || saved === '2') columns = saved; } catch (_) { /* Storage may be blocked. */ }
    setView(columns);
  };
  restoreView();
  desktop.addEventListener('change', restoreView);
  views.forEach(button => button.addEventListener('click', () => {
    const columns = button.dataset.gridColumns;
    setView(columns);
    try { localStorage.setItem(preferenceKey(), columns); } catch (_) { /* The view still works without storage. */ }
  }));
  const sortForm = browser.querySelector('[data-collection-sort]');
  sortForm.querySelector('select').addEventListener('change', () => sortForm.requestSubmit());
  const form = panel.querySelector('form');
  const min = form.querySelector('#CollectionPriceMin');
  const max = form.querySelector('#CollectionPriceMax');
  const range = panel.querySelector('[data-price-range]');
  if (range) {
    const minSlider = range.querySelector('[data-price-min-range]');
    const maxSlider = range.querySelector('[data-price-max-range]');
    const limit = Number(range.dataset.max);
    const paintRange = () => {
      range.style.setProperty('--range-min', `${limit ? Number(minSlider.value) / limit * 100 : 0}%`);
      range.style.setProperty('--range-max', `${limit ? Number(maxSlider.value) / limit * 100 : 100}%`);
    };
    const syncInputs = () => {
      max.setCustomValidity(min.value && max.value && Number(max.value) < Number(min.value) ? 'Maximum price must be greater than or equal to minimum price.' : '');
      minSlider.value = min.value || '0'; maxSlider.value = max.value || String(limit); paintRange();
    };
    minSlider.addEventListener('input', () => { min.value = String(Math.min(Number(minSlider.value), Number(maxSlider.value))); syncInputs(); });
    maxSlider.addEventListener('input', () => { max.value = String(Math.max(Number(maxSlider.value), Number(minSlider.value))); syncInputs(); });
    min.addEventListener('input', syncInputs); max.addEventListener('input', syncInputs); syncInputs();
  }
  form.addEventListener('submit', () => { form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled = true; }); });
  window.addEventListener('pageshow', () => { form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = false; }); unlock(); });

  const quickAdds = browser.querySelectorAll('[data-collection-quick-add]');
  if (quickAdds.length) {
    const root = window.Shopify?.routes?.root || '/';
    const notice = document.createElement('div');
    notice.className = 'hz-browse-cart-notice';
    notice.hidden = true;
    const message = document.createElement('span');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    const cartLink = document.createElement('a');
    cartLink.href = `${root}cart`;
    cartLink.textContent = 'View cart';
    const dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.textContent = '×';
    dismiss.setAttribute('aria-label', 'Dismiss cart notification');
    dismiss.addEventListener('click', () => { notice.hidden = true; });
    notice.append(message, cartLink, dismiss);
    document.body.append(notice);
    let noticeTimer;
    const notify = text => {
      clearTimeout(noticeTimer);
      notice.hidden = false;
      message.textContent = text;
      noticeTimer = setTimeout(() => { notice.hidden = true; }, 8000);
    };
    quickAdds.forEach(quickForm => quickForm.addEventListener('submit', async event => {
      event.preventDefault();
      const button = quickForm.querySelector('button');
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${quickForm.action}.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(quickForm)
        });
        const result = await response.json();
        if (!response.ok) {
          notify(result.description || result.message || 'This item could not be added. Please check your cart.');
          return;
        }
        button.classList.add('is-added');
        notify('Added to your cart');
        setTimeout(() => button.classList.remove('is-added'), 2000);
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(cartResponse => cartResponse.ok ? cartResponse.json() : null)
          .then(cart => {
            if (!cart || !Number.isInteger(cart.item_count)) return;
            document.querySelectorAll('.m27-header-cart__count').forEach(count => { count.textContent = String(cart.item_count); });
            document.querySelectorAll('a.m27-header-cart').forEach(link => { link.setAttribute('aria-label', `Cart, ${cart.item_count} items`); });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          }).catch(() => { /* Adding succeeded; a cart badge refresh must not report failure. */ });
      } catch (_) {
        notify('Could not confirm the addition. Check your cart before trying again.');
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }));
  }
})();
